import React, { createContext, useState, Dispatch, SetStateAction, PropsWithChildren } from 'react';

export interface AvailabilityData {
    locationId: string;
    unitId: string;
    selectedDate: string;
    slotRange: string;
    locationName: string;
    unitName: string;
    lockerNumber: number;
}

export interface UserTableData {
    name: string;
    bedrooms: string;
    contact: string;
    date: string;
    email: string;
    countryCode: string | number;
    locationName: string | null;
    companyName: string;
}

export interface LocationDetails {
    id: string;
    images: string[];
    name: string;
    provisioningId: string | number;
    timeZone: string;
    street1: string;
    street2: string;
    streetNumber: string;
    city: string;
    state: string;
    zip: string;
    description: string;
    lockerName: string;
    lockerNumber?: string[];
}

interface AvailabilityRedirectionContextProps {
    setAvailabilityData: Dispatch<SetStateAction<AvailabilityData>>;
    setSelectedUserTableData: Dispatch<SetStateAction<UserTableData>>;
    setLocationDetails: Dispatch<SetStateAction<LocationDetails>>;
    setUserId: Dispatch<SetStateAction<string>>;
    setSelectedSlotsIndex: Dispatch<SetStateAction<number[]>>;
    setData: Dispatch<SetStateAction<never[]>>;
    setStep: Dispatch<SetStateAction<number>>;
    availabilityData: AvailabilityData;
    selectedUserTableData: UserTableData;
    step: number;
    locationDetails: LocationDetails;
    data: never[];
    userId: string;
    selectedSlotsIndex: number[];
}

export const AvailabilityRedirectionContext = createContext<AvailabilityRedirectionContextProps | null>(null);

export const AvailabilityRedirectionProvider = ({ children }: PropsWithChildren<object>) => {
    const [availabilityData, setAvailabilityData] = useState<AvailabilityData>({
        locationId: '',
        unitId: '',
        selectedDate: '',
        slotRange: '',
        locationName: '',
        unitName: '',
        lockerNumber: 0,
    });
    const [selectedUserTableData, setSelectedUserTableData] = useState<UserTableData>({
        name: '',
        bedrooms: '',
        contact: '',
        date: '',
        email: '',
        countryCode: '',
        locationName: '',
        companyName: '',
    });
    const [locationDetails, setLocationDetails] = useState<LocationDetails>({
        id: '',
        images: [],
        name: '',
        provisioningId: '',
        timeZone: '',
        street1: '',
        street2: '',
        streetNumber: '',
        city: '',
        state: '',
        zip: '',
        description: '',
        lockerName: '',
        lockerNumber: [],
    });
    const [step, setStep] = useState(1);
    const [data, setData] = useState([]);
    const [userId, setUserId] = useState('');
    const [selectedSlotsIndex, setSelectedSlotsIndex] = useState<number[]>([]);

    return (
        <AvailabilityRedirectionContext.Provider
            value={{
                setAvailabilityData,
                availabilityData,
                selectedUserTableData,
                setSelectedUserTableData,
                setStep,
                step,
                locationDetails,
                setLocationDetails,
                data,
                setData,
                setUserId,
                userId,
                selectedSlotsIndex,
                setSelectedSlotsIndex,
            }}>
            {children}
        </AvailabilityRedirectionContext.Provider>
    );
};
